import SharedEndscreenPage from "@/features/_shared/pages/EndscreenPage";
import { dataProps } from "@/models/data.model";
import { FC, JSX } from "react";

import EndscreenUI from "./EndscreenUI";

const EndscreenPage: FC<dataProps> = (data): JSX.Element => (
  <SharedEndscreenPage {...data} UI={EndscreenUI} />
);

export default EndscreenPage;
